import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

// not-found.component.ts
interface ResourceLink {
    title: string;
    description: string;
    path: string;
}

@Component({
    selector: 'app-not-found',
    imports: [RouterModule],
    templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
    resourceLinks: ResourceLink[] = [
        {
            title: 'Dashboard',
            description: 'Ga naar het vestigingsdashboard',
            path: '/',
        },
        {
            title: 'Planning',
            description: 'Plan shifts en bekijk de planning',
            path: '/establishment/planning/shifts',
        },
        {
            title: 'Sales',
            description: 'Bekijk de sales van de vestiging',
            path: '/establishment/sales/overview',
        },
        {
            title: 'Contact',
            description: 'Neem contact met ons op voor vragen of hulp',
            path: '/contact',
        },
    ];
}
